<div class="app-wrapper d-flex flex-column"
    [ngClass]="{'justify-content-center': !isInitialized, 'align-items-center': !isInitialized}">

    <div class="app-content">
        @if (isInitialized) {
        <aoe-main-header></aoe-main-header>
        <router-outlet></router-outlet>
        } @else {
        <aoe-loading-spinner>
            <p info>Chargement de l'application AOE results</p>
        </aoe-loading-spinner>
        }
    </div>

    <aoe-footer></aoe-footer>
</div>